var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "26", height: "15", viewBox: "0 0 26 15", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Properties"
    ),
    React.createElement(
      "g",
      { fill: "#494444", fillRule: "evenodd" },
      React.createElement("path", { d: "M.684 8.021l4.452-4.185c.314-.295.457-.372.629-.422a.907.907 0 0 1 .518.001c.171.051.314.128.627.425l4.413 4.184a1 1 0 0 1-.689 1.726h-.351v3.968c0 .446-.047.607-.134.77a.909.909 0 0 1-.378.378c-.163.088-.324.134-.77.134H2.987c-.446 0-.607-.046-.77-.134a.909.909 0 0 1-.378-.378c-.087-.163-.134-.324-.134-.77V9.75H1.37a1 1 0 0 1-.685-1.729zM14.684 8.021l4.452-4.185c.314-.295.457-.372.629-.422a.907.907 0 0 1 .518.001c.171.051.314.128.627.425l4.413 4.184a1 1 0 0 1-.689 1.726h-.351v3.968c0 .446-.047.607-.134.77a.909.909 0 0 1-.378.378c-.163.088-.324.134-.77.134h-6.014c-.446 0-.607-.046-.77-.134a.909.909 0 0 1-.378-.378c-.087-.163-.134-.324-.134-.77V9.75h-.336a1 1 0 0 1-.685-1.729z" }),
      React.createElement("path", { d: "M17.371 4.122L14 7.293a2 2 0 0 0 .706 3.344V12h-3.422v-1.358a2 2 0 0 0 .728-3.343L8.65 4.113 12.136.836c.314-.295.457-.372.629-.422a.907.907 0 0 1 .518.001c.171.051.314.128.627.425l3.461 3.282z" })
    )
  );
});